import { render, staticRenderFns } from "./ReviewDateEdit.vue?vue&type=template&id=3a720888&scoped=true"
import script from "./ReviewDateEdit.vue?vue&type=script&lang=js"
export * from "./ReviewDateEdit.vue?vue&type=script&lang=js"
import style0 from "./ReviewDateEdit.vue?vue&type=style&index=0&id=3a720888&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a720888",
  null
  
)

export default component.exports